import React, { useState } from "react";

/**
 *  Component to display request or status message
 * @param {string} message message to display
 * @param {boolean} failed pass false if you wish display an error and true if success message
 */
const AlertMessage = ({ message, failed }) => {
	const [m, setM] = useState();
	if (message) {
		setTimeout(() => {
			const msg = message
				.replace("GraphQL error:", "")
				.replace("Network error:", "");
			setM(msg);
		}, 100);

		return (
			<div
				className={`alert fade-in ${
					failed ? "alert-danger" : "alert-success"
				}`}
				role="alert"
			>
				{m}
			</div>
		);
	}
	return null;
};

export default AlertMessage;
